import axios from "axios";
import API_BASE_URL from "@/config/api";

export default {
  namespaced: true,

  state: {
    report: {
      total_coffee: 0,
      total_income: 0,
      total_expenses: 0,
      net_profit: 0,
    },
  },

  mutations: {
    SET_REPORT(state, data) {
      state.report = data;
    },
  },

  actions: {
    // 📊 Récupérer le rapport depuis l'API PHP/MySQL
    async fetchReport({ commit }) {
      try {
        const { data } = await axios.get(`${API_BASE_URL}/report.php`);
        commit("SET_REPORT", {
          total_coffee: data.total_coffee || 0,
          total_income: data.total_income || 0,
          total_expenses: data.total_expenses || 0,
          net_profit: data.net_profit || 0,
        });
      } catch (error) {
        console.error("Erreur lors du calcul du rapport :", error);
      }
    },
  },

  getters: {
    getReport: (state) => state.report,
  },
};
